// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9ec40e13","940":"890e70c4"}[chunkId] + ".chunk.js";
};